export function dateTimeNow() {
    return new Date();
}
/**
 * RegExp to test a string for a full ISO 8601 Date
 * Does not do any sort of date validation,
 * only checks if the string is according to the ISO 8601 spec.
 *  YYYY-MM-DDThh:mm:ss
 *  YYYY-MM-DDThh:mm:ssTZD
 *  YYYY-MM-DDThh:mm:ss.sTZD
 * @see: https://www.w3.org/TR/NOTE-datetime
 * @type {RegExp}
 */
export var ISO_8601_FULL = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;
export function stringIsIso8601DateString(stringValue) {
    return ISO_8601_FULL.test(stringValue);
}
//# sourceMappingURL=DateHelpers.js.map